/* src/app/payroll/item/payroll-item-feature/payroll-item-feature.component.scss */
body#themeTag :host ::ng-deep {
  line-height: 1.5rem !important;
}
/*# sourceMappingURL=payroll-item-feature.component.css.map */
